/* import __COLOCATED_TEMPLATE__ from './get-started-link.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import type GreatGuidanceService from 'embercom/services/great-guidance-service';
import type AppService from 'embercom/services/app-service';
import type { Step } from 'embercom/objects/onboarding/checklist/step';

interface Args {}

interface Signature {
  Args: Args;
}

export default class StandaloneNavbarGetStartedLink extends Component<Signature> {
  @service declare appService: AppService;
  @service declare greatGuidanceService: GreatGuidanceService;
  @service declare router: RouterService;

  get app() {
    return this.appService.app;
  }

  get isOnGettingStartedRoute() {
    return this.router.currentRouteName.startsWith('apps.app.getting-started');
  }

  get totalOnboardingSteps() {
    return this.greatGuidanceService.steps.length;
  }

  get completedOnboardingSteps() {
    return this.greatGuidanceService.steps.filter((step: Step) => step.completed).length;
  }

  @action
  fetchStepsIfNeeded() {
    if (!this.greatGuidanceService.guide) {
      this.greatGuidanceService.fetchSteps(this.app.id);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Navbar::GetStartedLink': typeof StandaloneNavbarGetStartedLink;
    'standalone/navbar/get-started-link': typeof StandaloneNavbarGetStartedLink;
  }
}
